import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "left" }
const _hoisted_3 = { class: "right" }
const _hoisted_4 = { style: {"border":"1px solid #999","border-radius":"20px","padding":"4px 6px","margin-right":"10px"} }
const _hoisted_5 = { class: "el-dropdown-link" }

import Personal from './Personal.vue'
  import TagViews from '../TagsView/index.vue'
  import UHamburger from "@/components/u-Hamburger/index.vue"
  // import UScreenFull from '@/components/u-screenfull/index.vue'
  import {computed, ref,} from 'vue'
  import {useRouter} from 'vue-router'
  import { ElMessageBox, ElMessage } from 'element-plus'
  import {useStore} from "vuex";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

  const store = useStore()
  const person = ref()
  const router = useRouter()

  const isCollapse = computed(()=>{
    return !store.state.app.isCollapse
  })

  const userInfo = computed(()=>{
    return store.state.user.userInfo
  })

  const logOut = async ()=>{
    ElMessageBox.confirm(
        '确定退出登录吗？',
        '退出登录',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }
    )
        .then(async () => {
          try {
            await store.dispatch('user/logout')
            router.push({path:'/login'})
          }catch (e) {

          }
        })
        .catch(() => {

        })
  }

  const commandAction = (key:number)=>{
    switch (key){
      case 1:
        logOut()
        break;
      case 2:
        person.value.show()
        break;
    }
  }

  const handleCollapse = () => {
    store.commit('app/SET_COLLAPSE', isCollapse.value)
  }

return (_ctx: any,_cache: any) => {
  const _component_expand = _resolveComponent("expand")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_fold = _resolveComponent("fold")!
  const _component_User = _resolveComponent("User")!
  const _component_arrow_down = _resolveComponent("arrow-down")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!

  return (_openBlock(), _createElementBlock("div", {
    class: "m-layout-header",
    style: _normalizeStyle({left:`${isCollapse.value?'56':'266'}px`})
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, [
          (isCollapse.value)
            ? (_openBlock(), _createBlock(_component_el_icon, {
                key: 0,
                class: "icon",
                size: 30,
                color: "#99a7ba",
                onClick: handleCollapse
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_expand)
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_el_icon, {
                key: 1,
                class: "icon",
                size: 30,
                color: "#99a7ba",
                onClick: handleCollapse
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_fold)
                ]),
                _: 1
              }))
        ]),
        _createVNode(UHamburger)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_icon, null, {
            default: _withCtx(() => [
              _createVNode(_component_User)
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_el_dropdown, { onCommand: commandAction }, {
          dropdown: _withCtx(() => [
            _createVNode(_component_el_dropdown_menu, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_dropdown_item, { command: 1 }, {
                  default: _withCtx(() => _cache[0] || (_cache[0] = [
                    _createTextVNode("退出登录")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_5, [
              _createTextVNode(_toDisplayString(userInfo.value.username) + " ", 1),
              _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                default: _withCtx(() => [
                  _createVNode(_component_arrow_down)
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(TagViews),
    _createVNode(Personal, {
      ref_key: "person",
      ref: person
    }, null, 512)
  ], 4))
}
}

})